import React from "react";
import { Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { CardTitle } from "@/components/ui/card";
import { PatientSearchDropdown } from "@/components/PatientSearchDropdown";
import type { PatientSearchResult } from "@/types/treatment-overview";

interface TreatmentOverviewHeaderProps {
  isAdminFlow?: boolean;
  isConsultationFlow: boolean;
  selectedPatient: PatientSearchResult | null;
  onSelectPatient: (patient: PatientSearchResult) => void;
  onClearPatient: () => void;
}

export const TreatmentOverviewHeader = ({
  isConsultationFlow,
  selectedPatient,
  onSelectPatient,
  onClearPatient,
}: TreatmentOverviewHeaderProps) => {
  return (
    <div className="flex flex-col gap-4">
      {/* Title row */}
      <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
        <div className="space-y-1">
          <CardTitle className="z-h1 text-foreground">
            Treatment Overview
          </CardTitle>
          <p className="z-secondary text-muted-foreground">
            Patient service history, prescriptions, and treatment plans.
          </p>
        </div>

        {!isConsultationFlow && (
          <Button
            disabled
            className="h-10 gap-2 rounded-xl px-4 shadow-none z-button"
          >
            <Plus className="h-4 w-4" />
            Create New
          </Button>
        )}
      </div>

      {/* Patient search — admin flow only */}
      {!isConsultationFlow && (
        <div className="w-full max-w-xl">
          <PatientSearchDropdown
            selectedPatient={selectedPatient}
            onPatientSelect={(patient) => {
              if (patient) {
                onSelectPatient(patient as PatientSearchResult);
              } else {
                onClearPatient();
              }
            }}
            placeholder="Search by patient name or ID"
            className="w-full"
          />
        </div>
      )}
    </div>
  );
};
